import Whatsapp from './Whatsapp.vue';

export default Whatsapp;
